// Rules shared by the EOS-03 source-sizing forms (Transformer, DG, UPS).

// The redundancy modes every EOS-03 engine offers. Transformer, DG and UPS all use
// exactly these three values (transformerSizingContract, generatorSizingContract and
// the backend UPSRedundancyMode), so one rule serves the three forms.
export const SOURCE_REDUNDANCY_MODES = ["NONE", "N_PLUS_1", "TWO_N"] as const;

export type SourceRedundancyMode = (typeof SOURCE_REDUNDANCY_MODES)[number];

// The standby (or redundant) unit count the backend requires for each redundancy
// mode (schemas/transformer_sizing.py, generator_sizing.py, ups_sizing.py): NONE
// needs 0, N_PLUS_1 exactly 1, TWO_N the same number as the duty units. The forms
// show this rather than asking for it, so the rule can never be broken by typing.
//
// The mode arrives as the raw select value - a SourceRedundancyMode, or "" while the
// engineer has not chosen one yet - and any other value counts as no standby unit.
// Under TWO_N the duty text is passed through exactly as typed - blank or not a
// whole number included - so a bad value is reported once, against Duty units,
// instead of twice.
export function deriveStandbyUnits(
  redundancyMode: SourceRedundancyMode | string,
  dutyUnits: string,
): string {
  if (redundancyMode === "N_PLUS_1") {
    return "1";
  }

  if (redundancyMode === "TWO_N") {
    return dutyUnits;
  }

  return "0";
}
